module.exports = __webpack_public_path__ + "img/fr.dc3c45c4.svg";